export default import.meta.ROLLDOWN_FILE_URL_1WdnoMjddOtjty4hFToaIA